import React from "react";
import { styled } from "@mui/material/styles";
import { Chip } from "@mui/material";
import { css } from "@emotion/react";
import systemAIIcon from "assets/images/system-ai.svg";

type Props = {
  onClick?: () => any;
};

const IntelligenceTag: React.FC<Props> = ({ onClick }) => {
  return (
    <StyledChip
      label={"OI"}
      onClick={onClick}
      data-testId={"IntelligenceTag"}
      variant={"outlined"}
      icon={<img src={systemAIIcon} alt={"OI Icon"} />}
    />
  );
};

const StyledChip = styled(Chip)(
  ({ theme }) => css`
    font-weight: 500;
    font-size: 14px;
    line-height: 21px;
    letter-spacing: 0px;
    border: none;
    margin: 0;
    padding: 4px 5px;
    position: relative;
    color: #0a88c9;

    &::before {
      content: "";
      position: absolute;
      inset: 0;
      border-radius: 6px;
      padding: 1px;
      background: linear-gradient(90deg, #067bd6 0%, #13aba7 50%, #609f1e 100%);
      mask: linear-gradient(#000 0 0) content-box, linear-gradient(#000 0 0);
      mask-composite: exclude;
    }
  `
);

export default IntelligenceTag;
